import { __assign } from "tslib";
import BiliAjax from "@bilibili/bili-app-ajax";
import { getAppInfo, toast, getLogin } from "./index";
var http = new BiliAjax({
    transformRequest: function (obj) {
        var brVd = "[" + document.documentElement.clientWidth + "," + document.documentElement.clientHeight + "]";
        var brR = "[[" + window.screen.width + "," + window.screen.height + "][" + window.screen.availWidth + "," + window.screen.availHeight + "]," + window.screen.colorDepth + "," + window.screen.pixelDepth + "]";
        obj.br_vd = brVd;
        obj.br_r = brR;
        return obj;
    }
});
export function httpGet(url, params) {
    params = params || {
        query: {},
        hideError: true,
        customMessage: "",
        postError: false,
        needLogin: true
    };
    var query = params.query, hideError = params.hideError, customMessage = params.customMessage, postError = params.postError, _a = params.needLogin, needLogin = _a === void 0 ? true : _a;
    query = query || {};
    customMessage = customMessage || "";
    return getAppInfo()
        .then(function (containerInfo) {
        return http.get(url, __assign(__assign({}, query), containerInfo));
    })
        .then(function (res) {
        var code = res.code;
        if (code === -101 && needLogin) {
            getLogin();
            return res;
        }
        if (code !== 0) {
            if (!hideError) {
                toast(customMessage + " " + res.message);
            }
        }
        return res;
    })
        .catch(function (error) {
        var message = error.message;
        if (!hideError) {
            toast(customMessage + " " + message);
        }
        if (postError) {
            if (!window.__Fission) {
                console.error("请引入apm-report-pc来进行上报!");
            }
            else {
                var p = JSON.stringify(query);
                window.__Fission.custom({
                    type: "error",
                    msg: {
                        url: url,
                        p: p,
                        message: message
                    }
                });
            }
        }
        return Promise.reject(error);
    });
}
export function httpPost(url, params) {
    params = params || {
        data: {},
        hideError: true,
        customMessage: "",
        postError: false,
        needLogin: true
    };
    var data = params.data, hideError = params.hideError, customMessage = params.customMessage, postError = params.postError, _a = params.needLogin, needLogin = _a === void 0 ? true : _a;
    data = data || {};
    customMessage = customMessage || "";
    return getAppInfo()
        .then(function (containerInfo) {
        if (data && data.ua) {
            data.ua = "" + JSON.stringify(containerInfo);
        }
        return http.post(url, __assign(__assign({}, data), containerInfo));
    })
        .then(function (res) {
        var code = res.code;
        if (code === -101 && needLogin) {
            if (url.indexOf("reddot/clear") > -1) {
                return res;
            }
            getLogin();
            return res;
        }
        if (code !== 0) {
            if (!hideError) {
                toast(customMessage + " " + res.message);
            }
        }
        return res;
    })
        .catch(function (error) {
        var message = error.message;
        if (!hideError) {
            toast(customMessage + " " + message);
        }
        if (postError) {
            if (!window.__Fission) {
                console.error("请引入apm-report-pc来进行上报!");
            }
            else {
                var p = JSON.stringify(data);
                window.__Fission.custom({
                    type: "error",
                    msg: {
                        url: url,
                        p: p,
                        message: message
                    }
                });
            }
        }
        return Promise.reject(error);
    });
}
